module.exports = __webpack_public_path__ + "static/media/group--fire--dark.2d014c14.svg";